<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="当前编号/流水号名称/流水号类型/搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row>
          <el-form-item label="流水号名称">
            <el-input
              v-model.trim="form.serialName"
              placeholder="请输入流水号名称"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="流水号类型">
              <el-select
                v-model="form.serialType"
                placeholder="请选择流水号类型"
                clearable
                style="width:100%"
                size="small"
              >
                <el-option label="BILL" value="BILL" />
                <el-option label="ID" value="ID" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="日期格式">
              <el-select
                v-model="form.dateType"
                placeholder="请选择日期格式"
                clearable
                size="small"
              >
                <el-option label="年月日(yyyyMMdd)" value="yyyyMMdd" />
                <el-option label="年月(yyyyMM)" value="yyyyMM" />
                <el-option label="年(yyyy)" value="yyyy" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="特殊前缀">
              <el-input
                v-model.trim="form.specialPrefix"
                placeholder="亲请输入特殊前缀"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="单据前缀">
              <el-input
                v-model.trim="form.billPrefix"
                placeholder="亲请输入单据前缀"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="数字长度">
              <el-input-number
                clearable
                v-model="form.numberLength"
                placeholder="请输入流水号中的数字长度"
                controls-position="right"
                style="width:100%"
                :max="2147483647"
                :min="0"
                :step-strictly="true"
                :step="1"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="总长度">
              <el-input-number
                clearable
                v-model="form.totalLength"
                placeholder="请输入流水号总长度"
                controls-position="right"
                style="width:100%"
                :max="2147483647"
                :min="0"
                :step-strictly="true"
                :step="1"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top:10px">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="增长方式">
              <el-select v-model="form.isAddType">
                <el-option label="递增" value="A" />
                <el-option label="日递增" value="B" />
                <el-option label="月递增" value="C" />
                <el-option label="年递增" value="D" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item label="是否启用">
              <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
                <el-checkbox-group v-model="form.isActiveList">
                  <el-checkbox label="Y">已启用</el-checkbox>
                  <el-checkbox label="N">未启用</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top:10px">
          <el-form-item label="流水号生成日期">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <el-date-picker
                v-model="form.currentBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择流水号生成日期"
                style="width: 100%"
                @change="dateChanges()"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <el-date-picker
                v-model="form.currentEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="请选择流水号生成日期"
                style="width: 100%"
                @change="dateChanges()"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  isActiveList: ['Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      checkCurrentDate: false,
    }
  },
  created() {
    this.query()
  },
  methods: {
    dateChanges() {
      if (this.form.currentBeginDate && this.form.currentEndDate) {
        let currentBeginDateLong = new Date(
          this.form.currentBeginDate
        ).getTime()
        let currentEndDateLong = new Date(this.form.currentEndDate).getTime()

        if (currentEndDateLong < currentBeginDateLong) {
          this.$message.warning('结束日期不能提前于开始日期！')
          this.checkCurrentDate = true
        } else {
          this.checkCurrentDate = false
        }
      }
    },
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      if (this.checkCurrentDate) {
        this.$message.warning('结束日期不能提前于开始日期！')
        return
      }
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
